"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var sorterBtn = process.env.NODE_ENV === "production" ? {
  name: "fhj6g4",
  styles: "display:flex;align-items:center;font-weight:inherit;letter-spacing:inherit;cursor:pointer;position:relative"
} : {
  name: "1f9clt1-sorterBtn",
  styles: "display:flex;align-items:center;font-weight:inherit;letter-spacing:inherit;cursor:pointer;position:relative;label:sorterBtn;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var activeIcon = function activeIcon(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.table.activeSortIcon, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:activeIcon;"));
};

var sorter = function sorter(_ref) {
  var isSorted = _ref.isSorted,
      isSortedDesc = _ref.isSortedDesc,
      theme = _ref.theme;
  return /*#__PURE__*/(0, _react.css)("display:flex;flex-direction:column;margin-left:2px;position:absolute;right:-", (0, _util.rem)(14), ";top:50%;transform:translateY(-50%);svg{width:", (0, _util.rem)(14), ";height:", (0, _util.rem)(14), ";}&>span:first-of-type svg{transform:translateY(", (0, _util.rem)(8), ") rotate(-90deg);", isSorted && !isSortedDesc && activeIcon(theme), ";}&>span:last-of-type svg{transform:translateY(-", (0, _util.rem)(4), ") rotate(90deg);", isSortedDesc && activeIcon(theme), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:sorter;"));
};

var diabledBtn = process.env.NODE_ENV === "production" ? {
  name: "1q9jzaf",
  styles: "cursor:default;& *{pointer-events:inherit;}"
} : {
  name: "98j8jl-diabledBtn",
  styles: "cursor:default;& *{pointer-events:inherit;};label:diabledBtn;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var styles = {
  sorterBtn: sorterBtn,
  sorter: sorter,
  diabledBtn: diabledBtn
};
exports.styles = styles;
//# sourceMappingURL=HeaderCell.styles.js.map